import React, { Component } from 'react'
import { AutoComplete, Tag } from 'antd';
import { connect } from 'react-redux';
import { patternSearch } from '../redux/actions/patternSearch';

const Option = AutoComplete.Option;

// Reusable pattern-name typeahead for Supply.appliesToPatternIds (product and
// variant level). Multiple instances render at once on the AddSupply form, so
// search results are kept in local state, not read back from the shared
// patternSearch reducer — otherwise every instance would show whichever
// picker's results loaded last.
class PatternPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            results: [],
        };
    }

    handleSearch = (q) => {
        this.setState({ query: q });
        if (!q || !q.trim()) {
            this.setState({ results: [] });
            return;
        }
        this.props.dispatch(patternSearch(q.trim())).then(res => {
            let matches = (res && res.data && res.data.data) || [];
            this.setState({ results: matches });
        }).catch(() => {
            this.setState({ results: [] });
        })
    }

    handleSelect = (val, option) => {
        let selected = JSON.parse(option.props.value);
        let { value, onChange } = this.props;
        let current = value || [];
        if (!current.some(p => p._id === selected._id)) {
            onChange([...current, { _id: selected._id, patternName: selected.patternName }]);
        }
        this.setState({ query: '', results: [] });
    }

    handleRemove = (id) => {
        let { value, onChange } = this.props;
        onChange((value || []).filter(p => p._id !== id));
    }

    render() {
        let { query, results } = this.state;
        let { value, placeholder } = this.props;
        let selected = value || [];
        let options = results.filter(p => !selected.some(s => s._id === p._id));

        return (
            <div className="pattern-picker">
                <div className="pattern-picker-tags">
                    {selected.map(p => (
                        <Tag key={p._id} closable onClose={() => this.handleRemove(p._id)}>
                            {p.patternName}
                        </Tag>
                    ))}
                </div>
                <AutoComplete
                    style={{ width: 260 }}
                    value={query}
                    onSearch={this.handleSearch}
                    onSelect={this.handleSelect}
                    onChange={(v) => this.setState({ query: v })}
                    placeholder={placeholder || 'Search patterns by name…'}
                >
                    {options.map(p => (
                        <Option key={p._id} value={JSON.stringify(p)}>{p.patternName}</Option>
                    ))}
                </AutoComplete>
            </div>
        );
    }
}

export default connect()(PatternPicker);
